import { render, staticRenderFns } from "./TypeValidationForm.vue?vue&type=template&id=2e53d188&scoped=true"
import script from "./TypeValidationForm.vue?vue&type=script&lang=js"
export * from "./TypeValidationForm.vue?vue&type=script&lang=js"
import style0 from "./TypeValidationForm.vue?vue&type=style&index=0&id=2e53d188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e53d188",
  null
  
)

export default component.exports